export default __webpack_public_path__ + "static/media/bus-red.87219d7d.png";